import { useChatContext } from './ChatContext';

const useAnalytics = () => {
    const { handleAnalytics } = useChatContext();
    return handleAnalytics;
};

export default useAnalytics;
